import { type ColumnFilterItem, type Key } from 'antd/es/table/interface';
import dayjs, { type Dayjs } from 'dayjs';

import {
  DEFAULT_DATE_RANGE_PRESETS,
  getDateRangePresetLabel,
  isDateInRange,
  MONTH_DATE_RANGE_PRESETS,
  resolveDateRange,
  type TDateRangePreset,
} from './date-range';

export const COLUMN_DATE_RANGE_PRESETS: readonly TDateRangePreset[] = [
  ...DEFAULT_DATE_RANGE_PRESETS,
  ...MONTH_DATE_RANGE_PRESETS,
];

const isColumnPreset = (value: Key | boolean): value is TDateRangePreset =>
  COLUMN_DATE_RANGE_PRESETS.some(
    (preset: TDateRangePreset): boolean => preset === value,
  );

export const matchesDateRangePreset = (
  value: Key | boolean,
  date: Date | string,
  now: Dayjs = dayjs(),
): boolean =>
  isColumnPreset(value) &&
  isDateInRange(dayjs(date), resolveDateRange(value, now));

export function getDateRangeColumnFilter<T>(
  getDate: (record: T) => Date | string,
): {
  filters: ColumnFilterItem[];
  filterMultiple: boolean;
  filterSearch: boolean;
  onFilter: (value: Key | boolean, record: T) => boolean;
} {
  const now: Dayjs = dayjs();

  return {
    filters: COLUMN_DATE_RANGE_PRESETS.map(
      (preset: TDateRangePreset): ColumnFilterItem => ({
        text: getDateRangePresetLabel(preset, now),
        value: preset,
      }),
    ),
    filterMultiple: false,
    filterSearch: true,
    onFilter: (value: Key | boolean, record: T): boolean =>
      matchesDateRangePreset(value, getDate(record)),
  };
}
